<template>
  <div>
    <b-form-select
      @change="showConfirmation(value, $event)"
      :disabled="session.role != 'ce' && session.role != 'superadmin'"
      :value="value"
      class="my-0"
      :class="
        value === 'baru'
          ? 'text-warning'
          : '' || value === 'diproses'
          ? 'text-info'
          : '' || value === 'diterima'
          ? 'text-primary'
          : '' || value === 'ditolak'
          ? 'text-danger'
          : ''
      "
      id="input-1"
    >
      <option value="baru" class="text-warning">Baru</option>
      <option value="diproses" class="text-info">Diproses</option>
      <option value="diterima" class="text-primary">Diterima</option>
      <option value="ditolak" class="text-danger">Ditolak</option>
    </b-form-select>
  </div>
</template>

<script>
export default {
  props: ["value", "editClaim"],
  data: function () {
    return {
      unconfirmedValue: "",
      session: this.$session.get("jwt"),
    };
  },
  methods: {
    refresh() {
      this.$store.dispatch(
        "customerListModule/getCustomerListId",
        this.$route.params.id
      );
    },
    showConfirmation(newValue, e) {
      this.unconfirmedValue = e;
      const oldValue = this.value;
      this.$swal({
        title: "Ubah Status Customer??",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          const formData = new FormData();
          formData.append("status", e);
          this.$store
            .dispatch("customerListModule/putMitraStatus", {
              id: this.$route.params.id,
              formData,
            })
            .then((response) => {
              this.loading = false;
              this.refresh();
              this.$swal({
                title: "Change!",
                text: "Your status has been change.",
                type: "success",
                showConfirmButton: false,
                timer: 1000,
              });
              this.value = e;
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response;
              console.log(error);
            });
        } else {
          this.refresh();
          this.value = undefined;
        }
      });
    },
  },
};
</script>

<style>
</style>